import { Box, ConfirmationModal, Text } from '@modusign/design-system';
import moment from 'moment';
import { ReactNode } from 'react';

import { formatContact } from '@app/features/apply-react-signing/libs/formatter/formatContact';
import Host from '@app/store/Host';

interface InPersonSessionRestartModalProps {
  title: string;
  confirmButtonLabel: string;
  description: ReactNode;
  host?: Host;
  isOpen: boolean;
  createdAt?: Date;
  onConfirm: () => void;
  onClose: () => void;
}

export default function InPersonSessionRestartModal({
  title,
  confirmButtonLabel,
  host,
  description,
  isOpen,
  onConfirm,
  onClose,
  createdAt,
}: InPersonSessionRestartModalProps) {
  return (
    <ConfirmationModal
      closeButtonLabel="닫기"
      confirmButtonLabel={confirmButtonLabel}
      isOpen={isOpen}
      maxWidth="xs"
      title={title}
      variant="warning"
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <Text textAlign="center">{description}</Text>
      <Box
        as="ul"
        bg="boxBackgroundNeutralBase"
        display="block"
        mt={6}
        px={6}
        py={7}
        sx={{
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'boxBorderNeutralBase',
        }}
        textAlign="left"
        whiteSpace="pre-wrap"
      >
        <Text fontSize="sm">{`${
          createdAt ? `${moment(createdAt).format('lll')}에` : '이미'
        } ${host?.name} (${formatContact(
          'IN_PERSON',
          host?.contactInfo
        )})님이 대면서명을 진행한 이력이 있습니다.`}</Text>
      </Box>
    </ConfirmationModal>
  );
}
